export default function removeUndefinedArrayElements(array) {
    if (array === undefined) {
        return [];
    }
    return array.filter((element) => element !== undefined);
}
